import BookshelfIcon from "@assets/compass.svg";
import SignOut from "@assets/logout.svg";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { css, useTheme } from "@emotion/react";
import { Link } from "react-router";
import { IconButton, TertiaryButton } from "../bits/buttons";
import { FlexRowContainer } from "../bits/layout";
import { GridItem } from "../bits/layout/Grid";
import { Header } from "../bits/layout/Header";
import { useUser } from "../hooks/useUser";

import MenuIcon from "@assets/nav-menu-icon-open.svg";
import MenuIconClosed from "@assets/nav-menu-icon.svg";
import { ShelfSearch } from "./ShelfSearch";

import useMediaQuery from "@mui/material/useMediaQuery";
import { pxToRem } from "../../design/utils";

export const ManagementViewHeader = ({
  sidePanelOpen,
  setSidePanelOpen,
}: {
  sidePanelOpen: boolean;
  setSidePanelOpen?: (open: boolean) => void;
}) => {
  const theme = useTheme();
  const { signOut } = useAuthenticator();
  const { user } = useUser();
  const isMobile = useMediaQuery(
    `(max-width: ${theme.breakpoints.values.lg}px)`,
  );
  const isSmall = useMediaQuery(
    `(max-width: ${theme.breakpoints.values.sm}px)`,
  );

  return (
    <Header
      css={css`
        height: ${pxToRem(52)};
      `}
    >
      <GridItem
        span={3}
        css={css`
          display: flex;
          align-items: center;
          gap: 8px;
        `}
      >
        {setSidePanelOpen && (
          <IconButton
            onClick={() => setSidePanelOpen(!sidePanelOpen)}
            css={({ breakpoints, spacing }) => css`
              display: none;
              @media (max-width: ${breakpoints.values.lg}px) {
                display: flex;
                margin-left: ${spacing(0.5)};
              }
            `}
            src={sidePanelOpen ? MenuIconClosed : MenuIcon}
            alt="Menu"
          />
        )}
        {!isSmall && (
          <Link to="/">
            <IconButton
              css={css`
                box-shadow: none;
                background-color: transparent;
                width: 8rem;
              `}
              src={BookshelfIcon}
              alt="Compass"
              title="Home"
            />
          </Link>
        )}
      </GridItem>
      <GridItem
        span={9}
        css={css`
          display: flex;
          align-items: center;
          justify-content: space-between;

          @media (max-width: ${theme.breakpoints.values.lg}px) {
            grid-column: 6 / span 8;
          }

          @media (max-width: ${theme.breakpoints.values.sm}px) {
            grid-column: 4 / span 9;
          }
        `}
      >
        <div
          css={({ breakpoints }) => css`
            width: 500px;
            padding-right: 8px;
            @media (max-width: ${breakpoints.values.md}px) {
              min-width: 0;
            }
          `}
        >
          <ShelfSearch />
        </div>
        <FlexRowContainer>
          <div
            css={({ breakpoints }) => css`
              @media (max-width: ${breakpoints.values.lg}px) {
                display: none;
              }
            `}
          >
            {user?.email}
          </div>
          {isMobile ? (
            <IconButton
              onClick={signOut}
              src={SignOut}
              alt="Sign out"
              imgHeight="20px"
            />
          ) : (
            <TertiaryButton onClick={signOut}>Sign out</TertiaryButton>
          )}
        </FlexRowContainer>
      </GridItem>
    </Header>
  );
};
